import ShippingSection from '@/comman/ShippingSection';
import _ from 'lodash';
import React from 'react';

const CheckoutStepFive = (props) => {
    let { Status, shippingMethods, selectedShippingOption, _handleShippingChange, shippingLoading } = props;

    return (
        <div className='shipping_section '>
            {_.map(['oneTime', 'autoship'], (data, i) => {
                if (!Status) {
                    Status = (shippingMethods[`${data}ShipMethod`]?.length > 0)
                }
                return (
                    <React.Fragment key={data}>
                        {(shippingMethods[`${data}ShipMethod`]?.length > 0) &&

                            <ShippingSection section={(data === "oneTime") ? "Today's order" : ' SmartSave'}
                                {...{
                                    selectedCheck: selectedShippingOption[`${data}SelectedShipping`],
                                    shippingMethods: shippingMethods[`${data}ShipMethod`],
                                    _handleShippingChange,
                                }}
                            />
                        }
                        {(!Status && i === 0) &&
                            <div className='shipping_option_div mb-[34px]'>
                                <h3 style={{ textTransform: "capitalize" }} className='!mb-[10px] text-[20px]'>
                                    Shipping Method
                                </h3>
                                {shippingLoading && <p className='error'>Please enter your shipping address to see the available shipping methods</p>}
                                {(!shippingLoading) &&
                                    <p className='error mb-[10px]'>
                                        Note :- No shipping method available on selected address
                                    </p>
                                }
                            </div>
                        }
                    </React.Fragment>
                )
            })}
        </div>
    )
}

export default CheckoutStepFive